import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import CpapWrapper from "@components/layouts/cpapWrapper";

export default function CarInjuryJusticeHome(): ReactElement {
    return (
        <CpapWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions category="CPAP" domain="Cpap.Claims" />
            </div>
        </CpapWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
